<template>
    <div>
        <b-table borderless :fields="bootstrapTable.fields" :items="data">
            <template v-slot:cell(code)="data">
                <router-link class="text-data-link" :to="data.item.links.self"
                             v-text="data.item.data.attributes.code"/>
            </template>

            <template v-slot:cell(date)="data">
                <span v-text="data.item.data.attributes.date"/>
            </template>

            <template v-slot:cell(type)="data">
                <b-badge pill style="width: 68px;"
                         :variant="data.item.data.attributes.type === 'Initial' ? 'success' : 'info'"
                >{{ data.item.data.attributes.type }}
                </b-badge>
            </template>

            <template v-slot:cell(facility)="data">
                <span v-text="data.item.data.attributes.facility"/>
            </template>

            <template v-slot:cell(inspected_areas)="data">
                <span v-text="data.item.data.attributes.inspected_areas"/>
            </template>

            <template v-slot:cell(cap_due)="data">
                <span v-text="data.item.data.attributes.cap_due"/>
            </template>

            <template v-slot:cell(inspector)="data">
                <span v-text="data.item.data.attributes.inspector"/>
            </template>

            <template v-slot:cell(staying_for)="data">
                <span v-text="data.item.data.attributes.staying_for"/>
            </template>

            <template v-slot:cell(status)="data">
                <b-badge pill style="width: 73px;"
                         :variant="(data.item.data.attributes.status).toLowerCase() === 'completed' ? 'success' : 'warning'"
                >{{ data.item.data.attributes.status }}
                </b-badge>
            </template>

            <template v-slot:cell(updated_by)="data">
                <span v-text="data.item.data.attributes.updated_by"/>
            </template>

            <template v-slot:cell(updated_at)="data">
                <span v-text="data.item.data.attributes.updated_at"/>
            </template>
        </b-table>
    </div>
</template>

<script>
    export default {
        name: "LatestInspections",
        props: ['data'],
        data() {
            return {
                bootstrapTable: {
                    fields: [
                        {key: 'code', label: 'Code', tdClass: ''},
                        {key: 'date', label: 'Date', tdClass: 'text-muted'},
                        {key: 'type', label: 'Type', tdClass: 'text-muted'},
                        {key: 'facility', label: 'Facility', tdClass: 'text-muted'},
                        {key: 'inspected_areas', label: 'Total Area', tdClass: 'text-muted'},
                        {key: 'cap_due', label: 'CAP Due', tdClass: 'text-muted'},
                        {key: 'inspector', label: 'Inspector', tdClass: 'text-muted'},
                        {key: 'status', label: 'Status', tdClass: 'text-muted'},
                        {key: 'updated_by', label: 'Updated By', tdClass: 'text-muted'},
                        {key: 'updated_at', label: 'Updated At', tdClass: 'text-muted'},
                    ]
                }
            }
        },
    }
</script>

<style scoped>

</style>
